import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";



const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
    const [arrowEnable, setArrowEnable] = useState(true);
    const [loading, setLoading] = useState(false);



    const value = {
        arrowEnable,
        setArrowEnable,
        loading,
        setLoading,
    };

    return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppContext = () => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error("useAppContext must be used within AppProvider");
    }
    return context;
};
